export enum FileFormat {
  Pdf = 'PDF',
  Asice = 'ASICE',
}
